<template>
  <div class="ang-card ang-card">
    <div class="ang-card-body">
      <div class="alert alert-success ang-alert-success mt-3">
        <h5 class="ang-card-title">Dziękujemy za wypełnienie formularza</h5>
        <div>
          <div v-if="signal">
            <p>
              Twoje dane i zgody zostały z powodzeniem zapisane w naszej bazie.
            </p>
            <div>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone
                zgody.</span
              >
            </div>
          </div>

          <div class="row mt-4" v-else-if="oirp">
            <div class="col-md-4 d-md-none">
              <img
                src="/assets/img/NWW_signal_new.png"
                style="max-width: 100%; max-height: 100%; margin: 0 auto"
              />
            </div>
            <div class="col-md-12 align-items-stretch">
              <div
                class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
              >
                <!---->
                <!---->
                <div class="ang-card-body d-flex flex-column">
                  <h5 class="ang-card-title">
                    Dlaczego warto przystąpić do grupowego ubezpieczenia dla
                    OIRP?
                  </h5>
                  <div class="content p-3">
                    <ul style="list-style: disc" class="pl-5">
                      <li>
                        możliwość przystąpienia do ubezpieczenia pracownika,
                        partnera/ki oraz dorosłych dzieci - każdy może mieć
                        swoje ubezpieczenie
                      </li>
                      <li>
                        wysokie świadczenia za niską składkę dotyczące życia i
                        zdrowia
                      </li>
                      <li>prosty sposób zapisu - poprzez formularz online</li>
                      <li>
                        indywidualne płatności przez każdą osobę ubezpieczoną
                      </li>
                      <li>ochrona przez 24h na całym świecie</li>
                    </ul>
                    <div>
                      Najlepszy dla siebie pakiet ubezpieczenia wybierzesz,
                      wypełniając formularz. Do formularza zalogujesz się
                      hasłem:
                      <span class="font-semibold">A8LQ4S25</span>
                    </div>
                    <div class="flex">
                      <div class="d-none d-lg-block">
                        <a
                          href="https://syriusz-oferta.ergohestia.pl/login/040823088"
                          target="_blank"
                          class="btn ang-button ang-btn-lg _bg_color3 mt-4 ml-5 text-nowrap"
                          >PRZEJDŹ DO FORMULARZA
                        </a>
                      </div>
                    </div>
                    <a
                      href="https://syriusz-oferta.ergohestia.pl/login/040823088"
                      target="_blank"
                      class="btn ang-button ang-btn-lg _bg_color3 mt-4 ml-5 text-nowrap d-lg-none"
                      >PRZEJDŹ DO FORMULARZA
                    </a>
                    <div class="mt-5">
                      Jeśli masz jakiekolwiek pytania lub wątpliwości co do
                      oferty, skontaktuj się z nami pod adresem:
                      <span class="font-semibold">oirp@angfinanse.pl</span> lub
                      zadzwoń pod numer:
                      <span class="font-semibold">696 787 892</span>
                    </div>
                    <div class="mt-5">
                      <p>Koniecznie zapoznaj się też z dokumentami:</p>
                      <ul style="list-style: disc" class="pl-5">
                        <li class="font-semibold text-blue-600">
                          <a
                            href="https://angfinanse.pl/ubezpieczenia_oferta/OWU_Hestia_Rodzina_HR_01.15_20231016.pdf"
                            target="_blank"
                            >Ogólne Warunki Grupowego Ubezpieczenia na Życie
                            Pracowników i Ich Rodzin Hestia Rodzina</a
                          >
                        </li>
                        <li class="font-semibold text-blue-600">
                          <a
                            href="https://angfinanse.pl/ubezpieczenia_oferta/OWU_Medical_Assistance_MAS_01.12_20231016.pdf"
                            target="_blank"
                            >Ogólne Warunki Dodatkowego Grupowego Ubezpieczenia
                            Medical Assistance</a
                          >
                        </li>
                        <li class="font-semibold text-blue-600">
                          <a
                            href="https://angfinanse.pl/ubezpieczenia_oferta/Porownanie_wariantow.pdf"
                            target="_blank"
                            >Porównanie wariantów</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="base">
            <p>Twoje dane i zgody zostały zaktualizowane.</p>
            <div v-if="solicitor">
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane, udzielone zgody oraz
                dane kontaktowe Twojego Eksperta.</span
              >
            </div>
            <div v-else>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone
                zgody.</span
              >
            </div>
          </div>
          <div v-else>
            <p>
              Twoje dane i zgody zostały z powodzeniem zapisane w naszej bazie.
            </p>
            <div v-if="solicitor">
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane, udzielone zgody oraz
                dane kontaktowe Twojego Eksperta.</span
              >
            </div>
            <div v-else>
              <span
                >Na Twój adres e-mail wysłaliśmy podsumowanie wypełnienia
                formularza zawierające wprowadzone dane oraz udzielone zgody.
                Jeden z naszych Ekspertów skontaktuje się z Tobą najpóźniej w
                ciągu dwóch dni roboczych w celu przygotowania oferty. Jeżeli
                masz już wybranego Eksperta ANG, podaj mu poniższy kod:</span
              >
              <h5 class="ang-heading mt-3">{{ code }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div v-if="signal && data && data.url" class="text-center">
        <a
          :href="data.url"
          target="_blank"
          class="btn ang-button ang-btn-lg _bg_color3 mt-4 text-nowrap"
          >DOKOŃCZ ZAKUP
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["base", "solicitor", "code", "signal", "data", "oirp"],
};
</script>
